//import { Style } from "@material-ui/icons";
import { useField } from "formik";
import React from "react";
//import { Display } from "react-bootstrap-icons";
import { Form, Label, Select, DropdownProps  } from "semantic-ui-react";

let value_select:any

interface Props {
    placeholder: string;
    name: string;
    options: any;
    label?: string;
    id: string;
    defaultvalue?: any;
    onChange?: any;
    functionevent?:any;
    className?:any;
    readOnly?:any;
}

interface PropsNew {
    placeholder: string;
    name: string;
    options: any;
    label?: string;
    id: string;
    functionevent?:any;
}

interface PropsChange {
    placeholder: string;
    name: string;
    options: any[];
    label?: string;
    id: string;
    defaultvalue?: any;
    onChange?: any;
    functionevent?:any;
    className?:any;
    readOnly?:any;
}

export function MySelectInputEnLab(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                clearable
                search
                id={props.id}
                options={props.options}
                value={field.value || null}
                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                }}
                onBlur={() => helpers.setTouched(true)}
                placeholder={field.value}
               
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}


export function MySelectInput(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                clearable
                search
                id={props.id}
                options={props.options}
                value={field.value || null}

                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                }}
                
                onBlur={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
                style={{backgroundColor: "#E9E9E7 !important", border:"none !important", padding: "5px", height: "30px"}}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}



export function MySelectInputEdiciones(props: PropsNew) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                clearable
                search
                id={props.id}
                options={props.options}
                value={field.value || null}
                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                    if(props?.functionevent) props?.functionevent()
                }}
                onBlur={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
                style={{backgroundColor: "#E9E9E7 !important", border:"none !important", height: "30px"}}
                    
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectInputEdicionesControl(props: PropsNew) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                clearable
                search
                id={props.id}
                options={props.options}
                value={field.value}
                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                    if(props.functionevent) props.functionevent()
                }}
                onBlur={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
                
                />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectInputEdicionesControll(props: PropsNew) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                clearable
                search
                id={props.id}
                options={props.options}
                value={field.value}
                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                    if(props.functionevent) props.functionevent()
                }}
                onBlur={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
                
                />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectInputControl(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                search
                id={props.id}
                options={props.options}
                value={field.value || null}
                // defaultValue={props.defaultvalue || null}
                onChange={(e,d) => {
                    helpers.setValue(d.value)
                    valorr(d.value)
                    valor()
                }}
                onFocus={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
               
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectInputControlConv(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                className={props.className}
                search
                id={props.id}
                options={props.options}
                value={field.value || null}
                defaultValue={props.defaultvalue || null}
                onChange={props.onChange || null}
                onFocus={() => helpers.setTouched(true)}
                placeholder={props.placeholder}
                readOnly={props.readOnly}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectControlConv(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <Select 
                id={props.id}
                options={props.options}
                value={props.options || null}
                defaultValue={props.defaultvalue || null}
                onChange={props.onChange || null}
                placeholder={props.placeholder}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ): null}
        </Form.Field>
    )
}

export function MySelectInputControlConvChange(props: PropsChange) {
    const [field, meta, helpers] = useField(props.name);
  
    const handleChange = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
      helpers.setValue(data.value); // Actualiza el valor seleccionado en Formik
    };
  
    return (
      <Form.Field error={meta.touched && !!meta.error}>
        <label>{props.label}</label>
        <Select
          className={props.className}
          search
          id={props.id}
          options={props.options}
          value={field.value || null}
          defaultValue={props.defaultvalue || null}
          onChange={handleChange} // Usa la función handleChange para actualizar el valor seleccionado
          onFocus={() => helpers.setTouched(true)}
          placeholder={props.placeholder}
          readOnly={props.readOnly}
        />
        {meta.touched && meta.error ? (
          <Label basic color='red'>{meta.error}</Label>
        ) : null}
      </Form.Field>
    );
  }


function valorr(f:any){
    value_select = f
}

export function valor(){
    return value_select
}